import moment from "moment-timezone";

function totalGreaterThanOREqualToTaken(total, taken) {
    return Number(total) >= Number(taken);
}

function numberIsValid(number) {
    return Number(number) >= 0 && number !== '';
}

function expiryDateIsAfterMaximum(year, expiryDate) {
    const yearStart = moment(year, 'YYYY').startOf('year').format('YYYY-MM-DD');
    const maximumDate = moment(yearStart, 'YYYY-MM-DD').add(3, 'years').subtract(1, 'days').format('YYYY-MM-DD')
    return {
        result: moment(expiryDate).isAfter(maximumDate),
        maximumDate: maximumDate
    };
}

function expiryDateIsBeforeMinimum(year, expiryDate) {
    const yearStart = moment(year, 'YYYY').startOf('year').format('YYYY-MM-DD');
    const minimumDate = moment(yearStart, 'YYYY-MM-DD').add(2, 'years').subtract(1, 'days').format('YYYY-MM-DD')
    return {
        result: moment(expiryDate).isBefore(minimumDate),
        minimumDate: minimumDate
    };
}

function expiryDateDuplicate(annualAllowances) {
    const result = annualAllowances.filter((b, i, { [i - 1]: a }) => a?.expiry_date === b.expiry_date);
    return result.length > 0;
}

export default function EntitlementRecordRules(values) {
    let isValid = true;
    let errorMessage = [];

    const annualAllowances = values.annual_allowances;
    const sickAllowances = values.sick_allowances;

    if (expiryDateDuplicate(annualAllowances)) {
        isValid = false;
        errorMessage.push('Annual leave expiry date should not duplicate.');
    }

    annualAllowances.map(function (annualAllowance) {
        if (!totalGreaterThanOREqualToTaken(annualAllowance.total, annualAllowance.taken)) {
            isValid = false;
            errorMessage.push(annualAllowance.year + ' annual leave taken should not greater than total.');
        }

        if (!numberIsValid(annualAllowance.total)) {
            isValid = false;
            errorMessage.push('Invalid value of ' + annualAllowance.year + ' annual leave total.');
        }

        if (!numberIsValid(annualAllowance.taken)) {
            isValid = false;
            errorMessage.push('Invalid value of ' + annualAllowance.year + ' annual leave taken.');
        }

        if (!numberIsValid(annualAllowance.yearly_entitlement)) {
            isValid = false;
            errorMessage.push('Invalid value of ' + annualAllowance.year + ' annual leave yearly entitlement.');
        }

        const maximum = expiryDateIsAfterMaximum(annualAllowance.year, annualAllowance.expiry_date)

        if (maximum['result']) {
            isValid = false;
            errorMessage.push('Expiry date of ' + annualAllowance.year + ' should not greater than ' + maximum['maximumDate'] + '.');
        }

        const minimum = expiryDateIsBeforeMinimum(annualAllowance.year, annualAllowance.expiry_date)

        if (minimum['result']) {
            isValid = false;
            errorMessage.push('Expiry date of ' + annualAllowance.year + ' should not less than ' + minimum['minimumDate'] + '.');
        }

        if (!totalGreaterThanOREqualToTaken(annualAllowance.gov_leave_total, annualAllowance.gov_leave_balance)) {
            isValid = false;
            errorMessage.push(annualAllowance.year + ' annual leave government entitlement remaining should not greater than total.');
        }

        if (!numberIsValid(annualAllowance.gov_leave_total)) {
            isValid = false;
            errorMessage.push('Invalid value of ' + annualAllowance.year + ' annual leave government entitlement total.');
        }

        if (!numberIsValid(annualAllowance.gov_leave_balance)) {
            isValid = false;
            errorMessage.push('Invalid value of ' + annualAllowance.year + ' annual leave government entitlement remaining.');
        }
    })

    if (!totalGreaterThanOREqualToTaken(sickAllowances.total, sickAllowances.taken)) {
        isValid = false;
        errorMessage.push('Sick leave taken should not greater than entitled.');
    }

    if (!numberIsValid(sickAllowances.total)) {
        isValid = false;
        errorMessage.push('Invalid value of sick leave total.');
    }

    if (!numberIsValid(sickAllowances.taken)) {
        isValid = false;
        errorMessage.push('Invalid value of sick leave taken.');
    }

    return {
        'isValid': isValid,
        'errorMessage': errorMessage.join('\n')
    }
}
